const routes = [
    {
        name: 'HomePage',
        path: '/home',
        component: () => import(/* webpackPrefetch: true */ '@/pages/HomePage.vue')
    },
    {
        name: 'SoloGame',
        path: '/solo',
        component: () => import(/* webpackPrefetch: true */ '@/pages/SoloGamePage.vue')
    },
    {
        name: 'Leaderboard',
        path: '/leaderboard',
        component: () => import(/* webpackPrefetch: true */ '@/pages/LeaderboardPage.vue')
    },
    {
        name: 'Roadmap',
        path: '/roadmap',
        component: () => import(/* webpackPrefetch: true */ '@/pages/RoadmapPage.vue')
    },
    {
        name: 'MyBITCAT',
        path: '/my',
        component: () => import(/* webpackPrefetch: true */ '@/pages/MyBitcatPage.vue')
    },
    {
        name: 'MultiplayerGame',
        path: '/multiplayer-game',
        component: () => import(/* webpackPrefetch: true */ '@/pages/MultiplayerGamePage.vue')
    },
    {
        path: '/nft-market',
        name: 'nft-market',
        component: () => import(/* webpackPrefetch: true */ '@/pages/NftMarketPage.vue')
    },
    {
        name: 'GameDetails',
        path: '/games/:gameId',
        component: () => import(/* webpackPrefetch: true */ '@/pages/GameDetailsPage.vue')
    },
    {
        name: 'Player',
        path: '/player/:userTag',
        component: () => import(/* webpackPrefetch: true */ '@/pages/PlayerPage.vue')
    },
    {
        name: 'Arena',
        path: '/arena',
        component: () => import(/* webpackPrefetch: true */ '@/pages/ArenaPage.vue')
    },
    {
        name: 'HideSeek',
        path: '/hide-seek',
        component: () => import(/* webpackPrefetch: true */ '@/pages/HideSeekPage.vue'),
        props: route => ({ gameId: route.query.game }),
        meta: { requiresAuth: true }
    },
    {
        name: 'HideSeekGameDetails',
        path: '/hide-seek/:gameId',
        component: () => import(/* webpackPrefetch: true */ '@/pages/HideSeekGameDetailsPage.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/dao',
        name: 'Dao',
        component: () => import(/* webpackPrefetch: true */ '@/pages/DaoPage.vue')
    },
    {
        path: '/',
        name: 'Universe',
        component: () => import(/* webpackPrefetch: true */ '@/pages/UniversePage.vue')
    },
    // {
    //     path: '/dapp-test',
    //     name: 'DappTest',
    //     component: require(/* webpackPrefetch: true */ '@/components/RequestAirdrop').default,
    // },
    {
        path: '/changelog',
        name: 'Changelog',
        component: () => import(/* webpackPrefetch: true */ '@/pages/ChangelogPage.vue')
    },
    {
        path: '/ai-agent/create',
        name: 'CreateAgent',
        component: () => import(/* webpackPrefetch: true */ '@/pages/AiAgentFormPage.vue'),
        meta: {
          requiresAuth: true
        }
    },
    {
        path: '/ai-agent/update/:agentTag',
        name: 'UpdateAgent',
        component: () => import(/* webpackPrefetch: true */ '@/pages/AiAgentFormPage.vue'),
        meta: {
          requiresAuth: true
        }
    },
    {
        path: '/ai-agents',
        name: 'AiAgents',
        component: () => import(/* webpackPrefetch: true */ '@/pages/AiAgentsPage.vue'),
        meta: {
          requiresAuth: true
        }
    },
    {
        path: '/ai-agents/:agentTag',
        name: 'AiAgent',
        component: () => import(/* webpackPrefetch: true */ '@/pages/AiAgentPage.vue')
    },
    {
        path: '/about-bitcat-ai',
        name: 'AboutBitcatAi',
        component: () => import(/* webpackPrefetch: true */ '@/pages/AboutAiPage.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/pages/NotFoundPage.vue')
    }
]

const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        return savedPosition
    } else {
        return { top: 0 }
    }
}

export { routes as default, scrollBehavior }
